@if (resourceDef) {
  <dhs-form [action]="'ADD'" [config]="config" [fieldGroup]="resourceDef.form"
    (questionValueChanged)="questionValueChanged($event)" [data]="dialogConfig.data.data">
  </dhs-form>
}